import IconImage from "@assets/images/icon-image.svg?react";
import IconNews from "@assets/images/icon-news.svg?react";
import clsx from "clsx";

type DescriptionTagProps = {
  name?: "BigRead" | "PhotoStory";
  className?: string;
};

export default function DescriptionTag({
  name = "BigRead",
  className,
}: DescriptionTagProps) {
  const Icon = name === "BigRead" ? IconNews : IconImage;
  const text = name === "PhotoStory" ? "Photo Story" : "Big Read";

  return (
    <div
      className={clsx(
        "bg-button-secondary flex h-7 w-fit items-center gap-[5px] px-2 py-1",
        className,
      )}
    >
      <Icon className="size-6 shrink-0 text-white" />
      <p className="text-label-2 text-primary-on-dark shrink-0">{text}</p>
    </div>
  );
}
